<div class="container-fluid mt-4">
    <!---------------------13. Assistant Registrar - Amendments Start---------------------------->

    <div class="row">


        <div class="col-lg-12" *ngIf="this.currentUser?.roleId != 9">
            <div class="card">
                <div class="card-header">
                    <h5 class="election-title">📅 Amendments History</h5>
                </div>
                <div class="card-body">
                    <form [formGroup]="byLawsForm">
                        <div class="row">
                            <div class="col-lg-3 col-md-6 mb-3">
                                <label class="form-label">Society Type</label>
                                <select class="form-control" formControlName="societyType">
                                    <option selected disabled value="0">Select Society Type</option>
                                    <option *ngFor="let item of societyDropdownData" [value]="item.id">
                                        {{ item.name }}
                                    </option>
                                </select>
                            </div>

                            <div class="col-lg-12 text-end">
                                <button type="button" class="btn btn-primary" [disabled]="byLawsForm.invalid"
                                    (click)="submitSociety()"><i class="bi bi-search"></i> Search</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
        <div class="col-lg-12" *ngIf="this.currentUser?.roleId == 9">
            <div class="card">
                <div class="card-header">
                    <h5 class="election-title">📅 Amendments History</h5>
                </div>
                <div class="card-body">
                    <form [formGroup]="byLawsDateForm">
                        <div class="row">
                            <!-- <div class="col-lg-3 col-md-6 mb-3">
                                <label class="form-label">Select Date</label>
                                <input class="form-control" type="date" aria-placeholder="Select Date"
                                    formControlName="date">
                            </div> -->
                            <div class="col-lg-3 col-md-6 mb-3">
                                <label class="form-label">Select Date</label>
                                <input type="text" class="form-control" placeholder="Select Date" readonly
                                    (click)="startPicker.showPicker()"
                                    [value]="startPicker.value ? (startPicker.value | date:'MMM d, y') : ''" />
                                <input #startPicker type="date" class="form-control" aria-placeholder="Select Date"
                                    formControlName="date" style="position:absolute; opacity:0; pointer-events:none;" />

                            </div>

                            <div class="col-lg-12 text-end">
                                <button type="button" class="btn btn-primary" [disabled]="byLawsDateForm.invalid"
                                    (click)="submit()"><i class="bi bi-search"></i> Search</button>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>

        <div class="col-lg-12" *ngIf="this.currentUser?.roleId == 9" style="margin-top: 10px;">
            <div class="card">
                <div class="card-header">
                    <h5 class="election-title">📜 Amendments Details</h5>
                </div>
                <div class="card-body">
                    <div class="table-responsive" *ngIf="AmendmentsList && AmendmentsList.length > 0; else NoData">
                        <!-- <div class="d-flex justify-content-between align-items-center mb-1">
                        <h5 class="bold">Amendments Details</h5>
                      
                    </div> -->
                        <div class="overflow-auto" *ngIf="AmendmentsList && AmendmentsList.length > 0">
                            <ngx-datatable class="ngx-datatable billdata colored-header sm table-striped table-hover"
                                [rows]="AmendmentsList" [columns]="columns" [headerHeight]="50" [footerHeight]="50"
                                [rowHeight]="'auto'" [limit]="10" [externalPaging]="true" [count]="AmendmentsList.length"
                                [columnMode]="'force'" [virtualization]="false" [scrollbarV]="false"
                                [scrollbarH]="true">




                                <!-- Static Columns -->
                                <ngx-datatable-column name="#" prop="index" [sortable]="false" [width]="40">
                                    <ng-template let-row="row" ngx-datatable-cell-template let-rowIndex="rowIndex">
                                        {{ rowIndex +1 }}
                                    </ng-template>
                                </ngx-datatable-column>

                                <ngx-datatable-column name="Date" prop="Date" [sortable]="true" [width]="80">
                                    <ng-template let-row="row" ngx-datatable-cell-template>
                                        {{ row.Date | date}}
                                    </ng-template>
                                </ngx-datatable-column>

                                <ngx-datatable-column name="Total Amendments" prop="TotalAmmendments" [sortable]="true"
                                    [width]="120">
                                    <ng-template let-row="row" ngx-datatable-cell-template>
                                        {{ row.TotalAmmendments }}
                                    </ng-template>
                                </ngx-datatable-column>

                                <ngx-datatable-column name="Amendments To Add" prop="AmmendmentsToAdded"
                                    *ngIf="this.societyDetails.iSocietyId == 2" [sortable]="true">
                                    <ng-template let-row="row" ngx-datatable-cell-template>
                                        {{ row.AmmendmentsToAdded }}
                                    </ng-template>
                                </ngx-datatable-column>

                                <ngx-datatable-column name="Amendments To Change" prop="AmmendmentsToChange"
                                    *ngIf="this.societyDetails.iSocietyId == 2" [sortable]="true">
                                    <ng-template let-row="row" ngx-datatable-cell-template>
                                        {{ row.AmmendmentsToChange }}
                                    </ng-template>
                                </ngx-datatable-column>

                                <ngx-datatable-column name="Amendments To Remove" prop="AmmendmentsToRemove"
                                    *ngIf="this.societyDetails.iSocietyId == 2" [sortable]="true">
                                    <ng-template let-row="row" ngx-datatable-cell-template>
                                        {{ row.AmmendmentsToRemove }}
                                    </ng-template>
                                </ngx-datatable-column>

                                <ngx-datatable-column name="Status" prop="sAuditStatus" [sortable]="true">
                                    <ng-template let-row="row" ngx-datatable-cell-template>

                                        <span [ngClass]="
                             row.sAuditStatus === 'Approved' ?'badge bg-success':
                             row.sAuditStatus === 'Pending'?  'badge bg-warning':
                             row.sAuditStatus === 'Rejected'?  'badge bg-danger':''
">
                                            {{ row?.sAuditStatus }}
                                        </span>

                                    </ng-template>
                                </ngx-datatable-column>

                                <ngx-datatable-column name="Action" prop="Action" [sortable]="false">
                                    <ng-template let-row="row" ngx-datatable-cell-template>
                                        <div class="d-flex align-items-center gap-2">
                                            <a href="javascript:void(0)" class="btn btn-info btn-sm"
                                                data-bs-toggle="modal" data-bs-target="#AmendmentsAppDetails"
                                                (click)="getApplicationDetail(row)"> <i class="fa fa-eye"></i></a>

                                            <button *ngIf="row?.IsCompleted == 2" class="btn btn-primary btn-sm"
                                                title="Download Order" (click)="getByLawsOrderCertificate(row)"
                                                data-bs-toggle="modal" data-bs-target="#AmendmentsOrderDetails"><i
                                                    class="bi bi-download" aria-hidden="true"></i></button>
                                        </div>
                                    </ng-template>
                                </ngx-datatable-column>



                            </ngx-datatable>
                        </div>

                    </div>
                    <ng-template #NoData>
                        No Amendment Found.
                    </ng-template>
                </div>
            </div>
        </div>
        <div class="col-lg-12" *ngIf="this.currentUser?.roleId != 9">
            <div class="card">
                <div class="card-body">
                    <div class="table-responsive">

                        <ngx-datatable class="ngx-datatable billdata colored-header sm table-striped table-hover"
                            [rows]="AmendmentsList" [columns]="columns1" [columnMode]="'force'" [headerHeight]="50"
                            [footerHeight]="50" rowHeight="auto" [columnMode]="'force'" [virtualization]="false"
                            [scrollbarV]="false" [scrollbarH]="true">
                            <!-- Column Definitions -->
                            <!-- Column Definitions -->

                            <!-- Static Columns -->
                            <ngx-datatable-column *ngFor="let column1 of columns1; let i = index" [name]="column1.name"
                                [prop]="column1.prop" [sortable]="column1.sortable">

                                <ng-template ngx-datatable-cell-template let-row="row" let-rowIndex="rowIndex"
                                    let-column="column1">
                                    <ng-container [ngSwitch]="column1.prop">

                                        <!-- Serial Number Column -->
                                        <ng-container *ngSwitchCase="'id'">{{ rowIndex + 1 }}</ng-container>
                                        <ng-container *ngSwitchCase="'dCreateDate'">{{ row?.dCreateDate |
                                            date}}</ng-container>
                                        <ng-container *ngSwitchCase="'sAuditStatus'">
                                            <span [ngClass]="
                                     row.sAuditStatus === 'Approved' ?'badge bg-success':
                                     row.sAuditStatus === 'Pending'?  'badge bg-warning':
                                     row.sAuditStatus === 'Rejected'?  'badge bg-danger':''
">
                                                {{ row?.sAuditStatus }}
                                            </span>
                                        </ng-container>

                                        <ng-container *ngSwitchCase="'action'">

                                            <a href="javascript:void(0)" class="btn btn-primary btn-sm"
                                                data-bs-toggle="modal" data-bs-target="#AmendmentsAppDetails"
                                                (click)="getApplicationDetail(row)">Review Application</a>
                                        </ng-container>

                                        <ng-container *ngSwitchDefault>
                                            {{ row[column1.prop] }}
                                        </ng-container>
                                    </ng-container>
                                </ng-template>
                            </ngx-datatable-column>
                        </ngx-datatable>
                    </div>
                </div>
            </div>
        </div>


        <div class="modal fade" id="AmendmentsOrderDetails" data-bs-backdrop="static" data-bs-keyboard="false"
            tabindex="-1" aria-labelledby="AmendmentsAppDetailsLabel" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable">
                <div class="modal-content">
                    <!-- <div class="modal-header">
                        <h1 class="modal-title fs-5" id="AmendmentsAppDetailsLabel">Order Details</h1> &nbsp;
                        <a target="_blank" (click)="print()" class="btn btn-primary btn-sm"><i
                                class="fa fa-print"></i></a>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                            (click)="closeOrder()"></button>

                    </div> -->

                    <div class="modal-header d-flex justify-content-between align-items-center">

                        <h1 class="modal-title election-title mb-0" id="AmendmentsAppDetailsLabel">Order Details</h1> &nbsp;


                        <div class="d-flex align-items-center gap-2">
                            <a target="_blank" (click)="print()" class="btn btn-primary btn-sm"><i
                                    class="fa fa-print"></i></a>

                            <button type="button" class="btn btn-danger btn-sm" data-bs-dismiss="modal">
                                <i class="fa fa-times" (click)="closeOrder()"></i>
                            </button>
                        </div>

                    </div>

                    <div class="modal-body">
                        <div id="ordercontent">

                            <div class="center">
                                <!-- <strong>The Ekta Multipurpose Co-operative Society Ltd.</strong><br> -->
                                <strong>{{OrderCertiftcateData?.societyName}}</strong><br>
                                <small>Regd. No. {{OrderCertiftcateData?.societyRegistrationNo}}, dt.
                                    {{OrderCertiftcateData?.approvedate}}</small><br>
                                <!-- <small>Regd. Off: Village Rampur, PO Sutanpur, Tehsil & Distt. Solan H.P. 173229</small><br><br> -->
                                <small>Regd. Off:{{OrderCertiftcateData?.societyAddress}}</small><br><br>
                                <strong>Amendment Proposal in the Bye-Laws of Society</strong>
                            </div>

                            <table>
                                <tr>
                                    <th>Bye Laws</th>
                                    <th>Existing</th>
                                    <th>Proposed</th>
                                </tr>
                                <tr *ngFor="let bylaws of this.OrderCertiftcateData?.bylaws">
                                    <td>({{bylaws?.sByLawsNo}})
                                    <td>{{OrderCertiftcateData?.societyName}}&nbsp; : &nbsp;
                                        {{bylaws?.sExistByLawsDetail}}</td>
                                    <td>{{OrderCertiftcateData?.societyName}}&nbsp; : &nbsp;{{bylaws?.sNewByLawsDetail}}
                                    </td>
                                </tr>

                            </table>

                            <p>Certified that:</p>
                            <ol>
                                <li>The application has complied with the provisions of the Co-operative Act & Rules
                                    made
                                    thereunder.</li>
                                <li>The proposed amendments are not contrary to the Act & Rules.</li>
                                <li>The proposed amendments are suitable for carrying out the subjects/objects and for
                                    ensuring
                                    the successful conduct of the business of the society.</li>
                            </ol>

                            <p>
                                Further it is also certified that in the case of amendment of bye-laws No.1 & 7, the
                                provisions
                                of rule 8-A (8) of the H.P. Co-operative Societies Rules 1971 have been fully complied
                                with.
                            </p>

                            <div class="signature">
                                <div>
                                    <strong>Authorized Signatory<br>President</strong>
                                </div>
                                <div>
                                    <strong>Authorized Signatory<br>Secretary</strong>
                                </div>
                                <div>
                                    <strong>Registrar of Cooperative Societies<br>H.P. – 173206</strong>
                                </div>
                            </div>

                            <p class="note">Amended on date: 7th March 2023</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!---------------------13. Assistant Registrar - Amendments End---------------------------->


    <!---------------------13.1 Assistant Registrar - Amendments - Review Application - Application Details Start---------------------------->
    <!---------------------13.2 Assistant Registrar - Amendments - Review Application - Process Order Start---------------------------->
    <!---------------------13.3 Assistant Registrar - Amendments - Review Application - Status Details Start---------------------------->

    <div class="modal fade" id="AmendmentsAppDetails" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
        aria-labelledby="AmendmentsAppDetailsLabel" aria-hidden="true">
        <div class="modal-dialog modal-xl modal-dialog-scrollable">
            <div class="modal-content">
                <div class="modal-header">
                    <h1 class="modal-title election-title" id="AmendmentsAppDetailsLabel">Amendments Details</h1>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                        (click)="closeModel()"></button>

                </div>
                <div class="modal-header">
                    <div class="col-lg-12">
                        <div class="d-flex align-items-center gap-2 px-16 ">
                            <!-- <button type="button" class="btn btn-secondary btn-sm"  (click)="toggle(true)">Application Details</button>
                    <button type="button" class="btn btn-secondary btn-sm" (click)="toggle(false)">Status Details</button> -->


                            <button class="btn btn-secondary" (click)="toggle(1)">Application details</button>
                            <button class="btn btn-secondary" (click)="toggle(2)"
                                *ngIf="[11,13,19].includes( this.currentUser.roleId) || this.societyDetails?.iSocietyId == 2">Amendment
                                Accepted</button>
                            <button class="btn btn-secondary" (click)="toggle(3)">Status Details</button>


                        </div>

                    </div>

                </div>

                <div class="modal-body">
                    <div class="row">

                        <div class="col-lg-12" *ngIf="applicationModel==1">
                            <ng-container
                                *ngIf="[36,37,38].includes( this.currentUser.roleId) || this.societyDetails?.iSocietyId == 1">
                                <div>
                                    <div>

                                        <div class="d-flex align-items-center gap-2 mb-3 justify-content-between">
                                            <h6 class="election-title">Amendments Application Details</h6>
                                            <div>
                                                <select class="form-control" style="width: 150px;">
                                                    <option selected disabled>{{aplicationDetailList?.selectedRow?.Date
                                                        | date}}</option>
                                                </select>
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col-lg-12">
                                                <div class="d-flex align-items-center gap-2 mb-3">
                                                    <button type="button" class="btn btn-success btn-sm"
                                                        (click)="downloadFile(aplicationDetailList?.sFormIVPath)">Form
                                                        iv</button>
                                                    <button type="button" class="btn btn-success btn-sm"
                                                        (click)="downloadFile(aplicationDetailList?.sAuditedAccountReturnPath)">Audited
                                                        Accounts General House Meeting</button>
                                                    <button type="button" class="btn btn-success btn-sm"
                                                        (click)="downloadFile(aplicationDetailList?.sComparativeChartPath)">Comparative
                                                        chart
                                                    </button>
                                                    <button type="button" class="btn btn-success btn-sm"
                                                        (click)="downloadFile(aplicationDetailList?.sExecutiveBodyResolutionPath)">
                                                        Resolution Executive</button>
                                                    <button type="button" class="btn btn-success btn-sm"
                                                        (click)="downloadFile(aplicationDetailList?.sGeneralBodyResolutionPath)">Resolution
                                                        General Body
                                                    </button>
                                                </div>
                                            </div>

                                            <div class="col-lg-12">
                                                <h5 class="election-title">Amendments</h5>
                                                <!-- <div class="table-responsive"
                                                    *ngIf="aplicationDetailList?.byLawsDetails.length>0">
                                                    <ngx-datatable
                                                        class="ngx-datatable billdata colored-header sm table-striped table-hover"
                                                        [rows]="aplicationDetailList?.byLawsDetails" [headerHeight]="50"
                                                        [footerHeight]="50" [rowHeight]="'auto'" [limit]="10"
                                                        [count]="aplicationDetailList?.byLawsDetails.length"
                                                        [columnMode]="'force'" [virtualization]="false"
                                                        [scrollbarV]="false" [scrollbarH]="true"
                                                        [externalPaging]="true">
                                                        <ngx-datatable-column name="#" prop="index">
                                                            <ng-template let-row="row" ngx-datatable-cell-template
                                                                let-rowIndex="rowIndex">
                                                                {{ rowIndex+1 }}
                                                            </ng-template>
                                                        </ngx-datatable-column>

                                                        <ngx-datatable-column name="Amendment Type"
                                                            prop="amendmentType">
                                                            <ng-template let-row="row" ngx-datatable-cell-template>
                                                                {{ (row.sAmmendmentType == 1) ? 'Add' :
                                                                (row.sAmmendmentType == 2) ? 'Change' :
                                                                'Remove' }}
                                                            </ng-template>
                                                        </ngx-datatable-column>

                                                       

                                                        <ngx-datatable-column name="New Bye-laws"
                                                            prop="sNewByLawsDetail">
                                                            <ng-template let-row="row" ngx-datatable-cell-template>
                                                            
                                                                <app-read-more
                                                                    text="{{row.sNewByLawsDetail ?row.sNewByLawsDetail:'NA'}}"
                                                                    [maxLength]="15"
                                                                    (viewMore)="viewMore($event)"></app-read-more>
                                                            </ng-template>
                                                        </ngx-datatable-column>
                                                        <ngx-datatable-column name="Existing Bye-Laws"
                                                            prop="sExistByLawsDetail">
                                                            <ng-template let-row="row" ngx-datatable-cell-template>
                                                         
                                                                <app-read-more
                                                                    text="{{row.sExistByLawsDetail ?row.sExistByLawsDetail:'NA'}}"
                                                                    [maxLength]="15"
                                                                    (viewMore)="viewMore($event)"></app-read-more>
                                                            </ng-template>
                                                        </ngx-datatable-column>

                                                     

                                                        <ngx-datatable-column name="Action">
                                                            <ng-template let-row="row" ngx-datatable-cell-template>
                                                                <a href="javascript:void(0)" *ngIf="row.nocUpload "
                                                                    (click)="downloadFile(row.nocUpload)">
                                                                    Download
                                                                </a>
                                                            </ng-template>
                                                        </ngx-datatable-column>
                                                    </ngx-datatable>
                                                
                                                    <div class="modal fade animate-fade" id="readMoreModal"
                                                        tabindex="-1" aria-labelledby="readMoreModalLabel"
                                                        aria-hidden="true">
                                                        <div class="modal-dialog modal-dialog-scrollable">
                                                            <div class="modal-content">
                                                                <div class="modal-header">
                                                                    <h5 class="modal-title" id="readMoreModalLabel">Full
                                                                        Text</h5>
                                                                    <button type="button" class="btn-close"
                                                                        data-bs-dismiss="modal" aria-label="Close"
                                                                        (click)="hideViewMore()"></button>
                                                                </div>
                                                                <div class="modal-body">
                                                                    {{ ExpendeText }}
                                                                </div>
                                                                <div class="modal-footer">
                                                                    <button type="button" class="btn btn-secondary"
                                                                        data-bs-dismiss="modal"
                                                                        (click)="hideViewMore()">Close</button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div> -->

                                                <div class="table-responsive"
                                                    *ngIf="aplicationDetailList?.byLawsDetailsResponse?.length > 0">

                                                    <ngx-datatable
                                                        class="ngx-datatable billdata colored-header sm table-striped table-hover"
                                                        [rows]="aplicationDetailList?.byLawsDetailsResponse"
                                                        [headerHeight]="50" [footerHeight]="50" [rowHeight]="'auto'"
                                                        [limit]="10"
                                                        [count]="aplicationDetailList?.byLawsDetailsResponse.length"
                                                        [columnMode]="'force'" [virtualization]="false"
                                                        [scrollbarV]="false" [scrollbarH]="true"
                                                        [externalPaging]="true">

                                                        <!-- Index -->
                                                        <ngx-datatable-column name="#">
                                                            <ng-template let-rowIndex="rowIndex"
                                                                ngx-datatable-cell-template>
                                                                {{ rowIndex + 1 }}
                                                            </ng-template>
                                                        </ngx-datatable-column>

                                                        <!-- Amendment Type -->
                                                        <ngx-datatable-column name="Amendment Type">
                                                            <ng-template let-row="row" ngx-datatable-cell-template>
                                                                {{
                                                                row.sAmmendmentType == 1 ? 'Name Of the Society' :
                                                                row.sAmmendmentType == 2 ? 'Objective Change' :
                                                                row.sAmmendmentType == 3 ? 'Rule & Reguslation' :
                                                                row.sAmmendmentType == 4 ? 'Area of Operation' :
                                                                row.sAmmendmentType == 5 ? 'Address' : 'NA'
                                                                }}
                                                            </ng-template>
                                                        </ngx-datatable-column>

                                                        <!-- New By-laws -->
                                                        <ngx-datatable-column name="New By-laws">
                                                            <ng-template let-row="row" ngx-datatable-cell-template>
                                                                <app-read-more
                                                                    [text]="formatBylaws(row.sNewByLawsDetail)"
                                                                    [maxLength]="50" (viewMore)="viewMore($event)">
                                                                </app-read-more>
                                                            </ng-template>
                                                        </ngx-datatable-column>

                                                        <!-- Existing By-laws -->
                                                        <ngx-datatable-column name="Existing By-laws">
                                                            <ng-template let-row="row" ngx-datatable-cell-template>
                                                                <app-read-more
                                                                    [text]="formatBylaws(row.sExistByLawsDetail)"
                                                                    [maxLength]="50" (viewMore)="viewMore($event)">
                                                                </app-read-more>
                                                            </ng-template>
                                                        </ngx-datatable-column>
                                                        <ngx-datatable-column name="Reason">
                                                            <ng-template let-row="row" ngx-datatable-cell-template>
                                                                <app-read-more [text]="formatBylaws(row.reason)"
                                                                    [maxLength]="50" (viewMore)="viewMore($event)">
                                                                </app-read-more>
                                                            </ng-template>
                                                        </ngx-datatable-column>

                                                    </ngx-datatable>

                                                    <!-- Read More Modal -->
                                                    <div class="modal fade animate-fade" id="readMoreModal"
                                                        tabindex="-1" aria-labelledby="readMoreModalLabel"
                                                        aria-hidden="true">

                                                        <div class="modal-dialog modal-dialog-scrollable">
                                                            <div class="modal-content">

                                                                <div class="modal-header">
                                                                    <h5 class="modal-title" id="readMoreModalLabel">Full
                                                                        Text</h5>
                                                                    <button type="button" class="btn-close"
                                                                        data-bs-dismiss="modal" aria-label="Close"
                                                                        (click)="hideViewMore()">
                                                                    </button>
                                                                </div>

                                                                <div class="modal-body">
                                                                    {{ ExpendeText }}
                                                                </div>

                                                                <div class="modal-footer">
                                                                    <button type="button" class="btn btn-secondary"
                                                                        data-bs-dismiss="modal"
                                                                        (click)="hideViewMore()">
                                                                        Close
                                                                    </button>
                                                                </div>

                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>




                                        </div>

                                    </div>
                                </div>
                            </ng-container>
                            <ng-container
                                *ngIf="[11,13,19].includes( this.currentUser.roleId) || this.societyDetails?.iSocietyId == 2">
                                <div>
                                    <div>
                                        <div class="d-flex align-items-center gap-2 mb-3 justify-content-between">
                                            <h6 class="election-title">Amendments Application Details</h6>
                                            <div>
                                                <div>
                                                    <select class="form-control" style="width: 150px;">
                                                        <option selected disabled>
                                                            {{aplicationDetailList?.selectedRow?.Date ||
                                                            aplicationDetailList?.selectedRow?.dCreateDate | date}}
                                                        </option>
                                                    </select>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="row">
                                            <div class="col-lg-12">
                                                <div class="d-flex align-items-center gap-2 mb-3">
                                                    <button type="button" class="btn btn-success btn-sm"
                                                        (click)="downloadFile(aplicationDetailList?.fileProceedingGHMPath)">Proceeding
                                                        of Special General House Meeting</button>
                                                    <button type="button" class="btn btn-success btn-sm"
                                                        (click)="downloadFile(aplicationDetailList?.fileNoticeGHMPath)">Notice
                                                        for Special General House Meeting</button>
                                                    <button type="button" class="btn btn-success btn-sm"
                                                        (click)="downloadFile(aplicationDetailList?.fileMemberPresentPath)">Member
                                                        Attendance Sheet</button>
                                                    <button type="button" class="btn btn-success btn-sm"
                                                        (click)="downloadFile(aplicationDetailList?.fileProposedAmmendmentPath)">Annotated
                                                        Form</button>
                                                </div>
                                            </div>

                                            <div class="col-lg-12">
                                                <h5 class="election-title">Amendments</h5>
                                                <div class="table-responsive"
                                                    *ngIf="aplicationDetailList?.byLawsDetails && aplicationDetailList?.byLawsDetails.length>0">
                                                    <ngx-datatable
                                                        class="ngx-datatable billdata colored-header sm table-striped table-hover"
                                                        [rows]="aplicationDetailList?.byLawsDetails" [columns]="columns"
                                                        [headerHeight]="50" [footerHeight]="50" [rowHeight]="'auto'"
                                                        [limit]="10"
                                                        [count]="aplicationDetailList?.byLawsDetails.length"
                                                        [columnMode]="'force'" [virtualization]="false"
                                                        [scrollbarV]="false" [scrollbarH]="true"
                                                        [externalPaging]="true">
                                                        <ngx-datatable-column name="#" prop="index">
                                                            <ng-template let-row="row" ngx-datatable-cell-template
                                                                let-rowIndex="rowIndex">
                                                                {{ rowIndex +1 }}
                                                            </ng-template>
                                                        </ngx-datatable-column>

                                                        <ngx-datatable-column name="Amendment Type"
                                                            prop="amendmentType">
                                                            <ng-template let-row="row" ngx-datatable-cell-template>
                                                                {{ (row.sAmmendmentType == 1) ? 'Add' :
                                                                (row.sAmmendmentType
                                                                ==
                                                                2) ? 'Change' : 'Remove' }}
                                                            </ng-template>
                                                        </ngx-datatable-column>

                                                        <ngx-datatable-column name="Bye-laws Number" prop="sByLawsNo">
                                                            <ng-template let-row="row" ngx-datatable-cell-template>
                                                                {{ row.sByLawsNo }}
                                                            </ng-template>
                                                        </ngx-datatable-column>

                                                        <!-- <ngx-datatable-column name="Bylaws" prop="sNewByLawsDetail">
                                                    <ng-template let-row="row" ngx-datatable-cell-template>
                                                        {{ row.sNewByLawsDetail }}
                                                    </ng-template>
                                                </ngx-datatable-column> -->
                                                        <ngx-datatable-column name="New Bye-laws"
                                                            prop="sNewByLawsDetail">
                                                            <ng-template let-row="row" ngx-datatable-cell-template>
                                                                <!-- {{ row.sNewByLawsDetail }} -->
                                                                <app-read-more
                                                                    text="{{row.sNewByLawsDetail ?row.sNewByLawsDetail:'NA'}}"
                                                                    [maxLength]="15"
                                                                    (viewMore)="viewMore($event)"></app-read-more>
                                                            </ng-template>
                                                        </ngx-datatable-column>
                                                        <ngx-datatable-column name="Existing Bye-Laws"
                                                            prop="sExistByLawsDetail">
                                                            <ng-template let-row="row" ngx-datatable-cell-template>
                                                                <!-- {{ row.sNewByLawsDetail }} -->
                                                                <app-read-more
                                                                    text="{{row.sExistByLawsDetail ?row.sExistByLawsDetail:'NA'}}"
                                                                    [maxLength]="15"
                                                                    (viewMore)="viewMore($event)"></app-read-more>
                                                            </ng-template>
                                                        </ngx-datatable-column>
                                                        <ngx-datatable-column name="Liability" prop="isLiability">
                                                            <ng-template let-row="row" ngx-datatable-cell-template>
                                                                {{ (row.isLiablity == 1) ? 'Yes' : 'No' }}
                                                            </ng-template>
                                                        </ngx-datatable-column>

                                                        <ngx-datatable-column name="Action">
                                                            <ng-template let-row="row" ngx-datatable-cell-template>
                                                                <a href="javascript:void(0)"
                                                                    class="btn btn-primary btn-sm me-1"
                                                                    *ngIf="row.isLiablity === 1 && row.sRegistrarApprovalPath"
                                                                    (click)="downloadFile(row.sRegistrarApprovalPath)">
                                                                    <i class="bi bi-download"></i>
                                                                </a>
                                                                <button type="button"
                                                                    class="btn btn-primary btn-sm me-1"
                                                                    title="View Disclaimer" (click)="showDiclamer(row)">
                                                                    <i class="bi bi-eye"></i></button>
                                                            </ng-template>
                                                        </ngx-datatable-column>
                                                    </ngx-datatable>

                                                </div>

                                            </div>


                                            <!-- <div  id="disclaimerList">
                                        <ng-container *ngIf="showDisclamer">
                                        <div class="col-md-12" *ngFor="let option of disclamerOptions; let i = index">
                                            <div class="form-check">
                                              <input type="checkbox" class="form-check-input" [checked]="option.iDisclaimerId" [disabled]="true">
                                              <label class="form-check-label">{{ option.sDisclaimer }}</label>
                                            </div>
                                          </div>
                                        </ng-container>
                                        </div> -->

                                            <!-- <div class="col-lg-12">
                                        <div class="form-check">
                                            <input class="form-check-input" type="checkbox" value=""
                                                id="CheckAmendmentsFive" checked disabled>
                                            <label class="form-check-label" for="CheckAmendmentsFive">
                                                The Amendments in the By-laws have been made in the general meeting of
                                                the society in which quorum was present or in an adjourned general
                                                meeting of the society.
                                            </label>
                                        </div>
                                    </div>

                                    <div class="col-lg-12">
                                        <div class="form-check">
                                            <input class="form-check-input" type="checkbox" value=""
                                                id="CheckAmendmentsSix" checked disabled>
                                            <label class="form-check-label" for="CheckAmendmentsSix">
                                                Due notice to all the member along with agenda (i.e. amendment of
                                                Bye-Laws) was given.
                                            </label>
                                        </div>
                                    </div> -->

                                        </div>
                                    </div>
                                </div>
                            </ng-container>

                        </div>

                        <div class="col-lg-12" *ngIf="applicationModel == 2">
                            <div>
                                <div>
                                    <h6 class="election-title">Select Amendments for Orders</h6>

                                    <div class="table-responsive">

                                        <ngx-datatable
                                            class="ngx-datatable billdata colored-header sm table-striped table-hover"
                                            [rows]="orderData" [columns]="orderColumns" [columnMode]="'force'"
                                            [headerHeight]="50" [footerHeight]="50" rowHeight="auto"
                                            [columnMode]="'force'" [virtualization]="false" [scrollbarV]="false"
                                            [scrollbarH]="true">
                                            <!-- Column Definitions -->
                                            <!-- Column Definitions -->
                                            <ngx-datatable-column name="#" prop="index" [sortable]="false" [width]="40">
                                                <ng-template let-row="row" ngx-datatable-cell-template
                                                    let-rowIndex="rowIndex">
                                                    {{ rowIndex +1 }}
                                                </ng-template>
                                            </ngx-datatable-column>

                                            <ngx-datatable-column name="Bye-Laws Number" prop="sByLawsNo"
                                                [sortable]="true">
                                                <ng-template let-row="row" ngx-datatable-cell-template>
                                                    {{ row.sByLawsNo}}
                                                </ng-template>
                                            </ngx-datatable-column>
                                            <!-- <ngx-datatable-column name="byLaws" prop="sNewByLawsDetail" [sortable]="true">
                                            <ng-template let-row="row" ngx-datatable-cell-template>
                                                {{ row.sNewByLawsDetail}}
                                            </ng-template>
                                        </ngx-datatable-column> -->
                                            <ngx-datatable-column name="New Bye-laws" prop="sNewByLawsDetail">
                                                <ng-template let-row="row" ngx-datatable-cell-template>
                                                    <!-- {{ row.sNewByLawsDetail }} -->
                                                    <app-read-more
                                                        text="{{row.sNewByLawsDetail ?row.sNewByLawsDetail:'NA'}}"
                                                        [maxLength]="15" (viewMore)="viewMore($event)"></app-read-more>
                                                </ng-template>
                                            </ngx-datatable-column>
                                            <ngx-datatable-column name="Existing Bye-Laws" prop="sExistByLawsDetail">
                                                <ng-template let-row="row" ngx-datatable-cell-template>
                                                    <!-- {{ row.sNewByLawsDetail }} -->
                                                    <app-read-more
                                                        text="{{row.sExistByLawsDetail ?row.sExistByLawsDetail:'NA'}}"
                                                        [maxLength]="15" (viewMore)="viewMore($event)"></app-read-more>
                                                </ng-template>
                                            </ngx-datatable-column>
                                            <ngx-datatable-column [width]="40" [sortable]="false" [draggable]="false"
                                                [resizeable]="false" [canAutoResize]="false" headerClass="text-center"
                                                cellClass="text-center">
                                                <ng-template let-row="row" ngx-datatable-cell-template>
                                                    <input class="form-check-input" type="checkbox" value=""
                                                        id="CheckAmendmentsFive" [checked]="row?.IsActive" disabled>
                                                </ng-template>


                                            </ngx-datatable-column>

                                        </ngx-datatable>
                                        <!-- <table class="table table-hover align-middle text-nowrap table-bordered">
                        <thead>
                            <tr>
                                <th class="text-dark font-medium">#</th>
                                <th class="text-dark font-medium">Bylaws Number</th>
                                <th class="text-dark font-medium">Bylaws</th>
                                <th class="text-dark font-medium text-center">
                                    <input class="form-check-input" type="checkbox" value="" id="AmendmentsOrdersAll">
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>1</td>
                            <td></td>
                            <td></td>
                            <td class="text-center">
                                <input class="form-check-input" type="checkbox" value="" id="AmendmentsOrdersOne">
                            </td>
                            </tr>
                            <tr>
                                <td>2</td>
                            <td></td>
                            <td></td>
                            <td class="text-center">
                                <input class="form-check-input" type="checkbox" value="" id="AmendmentsOrdersOne">
                            </td>
                            </tr>
                            <tr>
                                <td>3</td>
                            <td></td>
                            <td></td>
                            <td class="text-center">
                                <input class="form-check-input" type="checkbox" value="" id="AmendmentsOrdersOne">
                            </td>
                            </tr>
                        </tbody>
                    </table> -->
                                    </div>

                                    <!-- <div class="text-end">
                                    <button type="button" class="btn btn-primary" (click)="orders()"> Order</button>
                                </div> -->
                                </div>
                            </div>
                        </div>


                        <div class="col-lg-12" *ngIf="applicationModel ==3">
                            <div class="row">
                                <div class="col-lg-12">
                                    <h6 class="election-title">Amendments Application Status</h6>
                                </div>
                                <div class="col-lg-6">
                                    <div class="card">
                                        <div class="card-body">
                                            <div class="step-progressbar">
                                                <div class="v-progress progress-area">
                                                    <ul>

                                                        <li *ngFor="let item of bylawsProgress"
                                                            [class]="item?.ProgressClass">{{item?.AuditStatus}} - <small
                                                                style="font-size: 12px;">{{item?.dCreatedDate |
                                                                date:"dd/MM/yyyy"}}</small> <br>
                                                            <b style="font-size: 12px;">( {{item?.RoleName}} )</b>

                                                        </li>
                                                        <!-- <li class="v-progress-item completed">Application Submitted <br>
                                                        <small style="font-size: 12px;">DD/MM/YYYY</small>
                                                    </li>
                                                    <li class="v-progress-item inprogress">Block Inspector Review
                                                        <br><small style="font-size: 12px;">DD/MM/YYYY</small>
                                                    </li>
                                                    <li class="v-progress-item inprogress">Block Inspector Review
                                                        <br><small style="font-size: 12px;">DD/MM/YYYY</small>
                                                    </li>
                                                    <li class="v-progress-item inprogress">Block Inspector Review
                                                        <br><small style="font-size: 12px;">DD/MM/YYYY</small>
                                                    </li>
                                                    <li class="v-progress-item inprogress">Block Inspector Review
                                                        <br><small style="font-size: 12px;">DD/MM/YYYY</small>
                                                    </li> -->
                                                    </ul>
                                                </div>
                                            </div>
                                            <!-- <div class="timeline-process">
                                                <ul class="timeline">
                                                    <li class="topic" *ngFor="let item of bylawsProgress">

                                                        <div class="relative">
                                                            <label>{{ item.AuditStatus }} by
                                                                {{ item.RoleName }} <br /><span class="time">{{
                                                                    item.dCreatedDate | date }}</span>
                                                            </label>

                                                            <span class="circle"></span>
                                                        </div>

                                                    </li>
                                                </ul>
                                            </div> -->

                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-6" >
                                    <div class="card">
                                        <div class="card-body">
                                            <div class="row">

                                                <div class="col-lg-12">
                                                    <h5>Filter</h5>
                                                </div>
                                                <form [formGroup]="updateStatusForm">
                                                    <div class="row">
                                                        <div class="col-lg-6 col-md-6 mb-3">
                                                            <label class="form-label">Select Role</label>
                                                            <select class="form-control" formControlName="role"
                                                                aria-placeholder="Select Role"
                                                                (change)="changeRole($event)">
                                                                <option selected disabled value="">Select Role</option>
                                                                <option *ngFor="let role of roles"
                                                                    [value]="role?.RoleId">
                                                                    {{role?.RoleName}}</option>
                                                            </select>
                                                            <!-- <span style="font-size: small;"> You can only view remarks from
                                                            other roles; updates are not permitted.</span> -->
                                                        </div>
                                                        <div
                                                            class="col-lg-6 col-md-6 mb-3 d-flex justify-content-center align-items-center">
                                                            <div *ngIf="selectedRemarkDetails?.FilePath" class="mt-4">

                                                                <a href="javascript:void(0)"
                                                                    class=" btn btn-outline-info float-end"
                                                                    (click)="downloadFile(selectedRemarkDetails.FilePath)">Download
                                                                    Document </a>
                                                            </div>
                                                        </div>

                                                        <div *ngIf="selectedRemarkDetails">

                                                            <div *ngIf="selectedRemarkDetails?.remark">
                                                                <label class="form-label">Remarks</label>
                                                                <!-- {{selectedRemarkDetails?.remark}} -->
                                                                <textarea class="form-control"
                                                                    [value]="selectedRemarkDetails?.remark"
                                                                    disabled="true"
                                                                    placeholder="Please Enter Remark Here..."
                                                                    rows="4"></textarea>
                                                            </div>

                                                        </div>






                                                    </div>



                                                </form>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- Read More Model -->
                        <div class="modal fade animate-fade" id="readMoreModal" tabindex="-1"
                            aria-labelledby="readMoreModalLabel" aria-hidden="true">
                            <div class="modal-dialog modal-dialog-scrollable">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <h5 class="modal-title election-title" id="readMoreModalLabel">Full Text</h5>
                                        <button type="button" class="btn-close" data-bs-dismiss="modal"
                                            aria-label="Close" (click)="hideViewMore()"></button>
                                    </div>
                                    <div class="modal-body">
                                        {{ ExpendeText }}
                                    </div>
                                    <div class="modal-footer">
                                        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"
                                            (click)="hideViewMore()">Close</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!---------------------13.1 Assistant Registrar - Amendments - Review Application - Application Details End---------------------------->
        <!---------------------13.2 Assistant Registrar - Amendments - Review Application - Process Order End---------------------------->
        <!---------------------13.3 Assistant Registrar - Amendments - Review Application - Status Details End---------------------------->


        <div class="modal fade" id="remarkDetails" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
            aria-labelledby="remarkDetailsLabel" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h1 class="modal-title fs-5" id="remarkDetailsLabel">Disclaimer Details</h1>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
                            (click)="closeRemarkModel()"></button>

                    </div>


                    <div class="modal-body">
                        <div class="card-body">
                            <div class="step-progressbar">
                                <div>
                                    <div id="disclaimerList">
                                        <ng-container *ngIf="showDisclamer">
                                            <div class="col-md-12"
                                                *ngFor="let option of disclamerOptions; let i = index">
                                                <div class="form-check">
                                                    <input type="checkbox" class="form-check-input"
                                                        [checked]="option.iDisclaimerId" [disabled]="true">
                                                    <label class="form-check-label">{{ option.sDisclaimer }}</label>
                                                </div>
                                            </div>
                                        </ng-container>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- <div class="col-lg-12 col-md-6 mb-3" *ngIf="selectedRemarkDetails?.FilePath">
                    <label class="form-label"></label>
                    <a href="javascript:void(0)" class=" mt-5 btn btn-secondary"
                        (click)="downloadDocument(selectedRemarkDetails.FilePath)">Download
                        Document </a>
                </div> -->
                    </div>
                </div>
            </div>
        </div>
    </div>